import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import "./Inscription.css";
import logoIcam from '../../static/img/1200px-logo-icam---2008-1-43@2x.png';
import { useAuth } from "../../context/AuthContext";

function Inscription() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const history = useHistory();
  const { login } = useAuth();

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    if (password.length < 6) {
      setError("Password must contain at least 6 characters");
      return;
    }

    setIsLoading(true);

    try {
      if (!process.env.REACT_APP_API_URL) {
        throw new Error("API URL is not defined");
      }

      console.log("Tentative d'inscription avec:", { username });

      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/register",
        { username, password },
        {
          headers: {
            "Content-Type": "application/json",
            "ngrok-skip-browser-warning": "true",
          },
        }
      );

      console.log("Réponse du serveur:", response.data);

      // ðŸ”‘ Récupérer token dans tous les cas possibles
      const token =
        response.data?.access_token ||
        response.data?.token ||
        response.data?.jwt ||
        response.data?.authToken ||
        response.data?.user?.token ||
        null;

      if (!token) {
        localStorage.removeItem("token");
        localStorage.removeItem("isAuthenticated");
        localStorage.removeItem("isAdmin");
        localStorage.setItem("username", username);
        history.push("/login");
        return;
      }

      // âœ”ï¸ Stocker token
      localStorage.setItem("token", token);
      console.log("ðŸ” Token stocké :", token);

      // ðŸ‘¤ âœ”ï¸ Stocker userId et enterpriseId si renvoyés
      if (response.data?.user) {
        if (response.data.user.id) {
          localStorage.setItem("userId", response.data.user.id);
          console.log("userId stocké :", response.data.user.id);
        }

        if (response.data.user.enterpriseId) {
          localStorage.setItem("enterpriseId", response.data.user.enterpriseId);
          console.log("enterpriseId stocké :", response.data.user.enterpriseId);
        }
      }

      // âœ”ï¸ Stocker état d'authentification
      localStorage.setItem("isAuthenticated", "true");
      localStorage.setItem("isAdmin", "false"); 
      localStorage.setItem("username", username);

      // âœ”ï¸ Mise à  jour du contexte
      login(false);

      // ðŸ” Redirection
      setTimeout(() => {
        window.location.href = "/home";
      }, 100);

    } catch (error) {
      console.error("Erreur d'inscription:", error);

      if (error.response && error.response.status === 400) {
        setError("This username already exists");
      } else if (error.response) {
        setError(
          `Error ${error.response.status}: ${
            error.response.data.detail || "Registration error"
          }`
        );
      } else if (error.request) {
        setError(
          "Server not responding. Check your connection or backend."
        );
      } else {
        setError(error.message || "Registration error.");
      }

    } finally {
      setIsLoading(false);
    }
  };

  const navigateToLogin = () => {
    history.push("/");
  };

  return (
    <div className="inscription-container">
      <div className="inscription-card">
        <div className="inscription-left">
          <div className="inscription-form-container">
            <h1 className="inscription-title">Create an Account</h1>
            {error && <div className="inscription-error">{error}</div>}

            <form onSubmit={handleRegister} className="inscription-form">
              <div className="inscription-input-group">
                <label htmlFor="username">Username</label>
                <input
                  type="text"
                  id="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  placeholder="Choose a username"
                />
              </div>

              <div className="inscription-input-group">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="Create a password"
                />
              </div>

              <div className="inscription-input-group">
                <label htmlFor="confirmPassword">Confirm Password</label>
                <input
                  type="password"
                  id="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  placeholder="Confirm your password"
                />
              </div>

              <button type="submit" className="inscription-button" disabled={isLoading}>
                {isLoading ? "Registering..." : "Register"}
              </button>
            </form>

            <div className="inscription-footer">
              <p>Already have an account?</p>
              <button
                type="button"
                onClick={navigateToLogin}
                className="login-link"
              >
                Login
              </button>
            </div>
          </div>
        </div>

        <div className="inscription-right">
          <div className="inscription-logo-container">
            <img
              src={logoIcam}
              alt="ICAM Logo"
              className="inscription-logo"
            />
          </div>
          <h2 className="inscription-welcome">Join the Supply Chain Platform</h2>
          <p className="inscription-description">
            Create your account to access all our services and manage your supply chain projects.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Inscription;

